import { COLORS } from 'helpers/globals'

export default {
  modal: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100vw',
    zIndex: 10,
    background: 'rgba(0, 0, 0, 0.5)'
  },
  container: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%,-50%)',
    background: 'white',
    overflowX: 'hidden',
    '& hr': {
      border: 'none',
      borderTop: '1px solid',
      margin: '2rem 0',
      opacity: '.5'
    }
  },
  header: {
    width: '100%',
    color: 'white',
    padding: '1rem',
    backgroundColor: COLORS.primary
  },
  title: {
    display: 'inline-block',
    minHeight: '1rem'
  },
  saveMessage: {
    float: 'right',
    width: '7rem'
  },
  body: { padding: '2rem' },
  close: {
    cursor: 'pointer',
    marginRight: '1rem',
    float: 'right',
    color: 'white',
    fontSize: '2.4rem',
    '&:hover': {
      opacity: 0.5
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal/style.js